// apiClient.ts
/* eslint-disable no-restricted-globals */
import axios from "axios";
import { getAuthToken } from "../utils/authUtils";

// CRITICAL: All API calls use relative URLs
// The package.json proxy forwards /api/* requests to localhost:3001
// This works for both main thread and Web Workers
const baseURL = "";

// Global auth token for worker context
let globalAuthToken: string | null = null;

export const setWorkerAuthToken = (token: string | null) => {
  globalAuthToken = token;
};

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Use global auth token (for worker context) or get from cookies (for main thread)
    const token = globalAuthToken || getAuthToken();
    
    if (token && !config.headers?.Authorization) {
      config.headers = {
        ...(config.headers as any),
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle specific status codes
      if (error.response.status === 401) {
        // Token expired or unauthorized → logout user
        localStorage.removeItem("token");
        // You might also want to redirect:
        // window.location.href = "/login";
      }

      if (error.response.status === 403) {
        console.error("Forbidden: You don't have permission.");
      }

      if (error.response.status >= 500) {
        console.error("Server error, please try again later.");
      }
    } else if (error.request) {
      console.error("No response received from server.");
    } else {
      console.error("Error setting up request:", error.message);
    }

    return Promise.reject(error);
  }
);

export default api;
